module.exports = __webpack_public_path__ + "img/20180815_152858_232.e5cbff4e.jpg";